<template>
  <v-form
    ref="form"
    lazy-validation
  >
    <v-card>
      <v-card-text>
        <v-container v-if="isPermission('location-images.create')">
          <v-row>
            <v-col
              cols="12"
              sm="6"
            >
              <v-file-input
                v-model="options.location_image"
                dense
                accept="image/png, image/jpeg, image/bmp"
                prepend-icon="mdi-camera"
                :label="$t('image_*')"
                :rules="[rules.required, rules.file_size]"
              />
            </v-col>
            <v-col
              cols="12"
              sm="6"
            >
              <v-btn
                color="primary"
                small
                :loading="isLoading"
                @click="saveLocationImage"
              >
                Submit
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
        <location-images-list
          v-if="isPermission('location-images.list')"
          :row="item"
        />
      </v-card-text>
      <v-card-actions>
        <!-- <small>{{ $t("indicates_required_field") }}</small> -->
        <v-spacer />
        <v-btn
          color="red darken-1"
          text
          @click="closeForm()"
        >
          Close
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-form>
</template>
<script>
import { validationRules } from "@/mixins/validationRules";
import { mapGetters } from "vuex";

export default {
  components: {
    LocationImagesList: () => import("./LocationsImagesList.vue"),
  },
  mixins: [validationRules],
  props: {
    item: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      isLoading: false,
      options: {},
      //
    };
  },
  computed: {
    ...mapGetters({
      authUser: "getUser",
      //
    }),
  },

  async mounted() {},
  methods: {
    isPermission(val) {
      return this.$admin.can(val);
    },
    async saveLocationImage() {
      if (this.$refs.form.validate()) {
        this.options.location_id = this.item?.id;
        this.isLoading = true;
        await this.$store
          .dispatch("csmsLocations/addLocationImage", this.options)
          .then(() => {
            this.$store.dispatch(
              "alerts/success",
              this.$t("uploaded_successfully")
            );
            this.$refs.form.reset();
            // this.fetchLocationImageList();
          })
          .catch((error) => {
            this.$store.dispatch("alerts/error", error.response?.data?.message);
          })
          .finally(() => (this.isLoading = false));
        //     this.$emit("onsave", this.options);
      }
    },
    closeForm() {
      this.$refs.form.reset();
      this.$emit("onclose");
    },

    // when Img Add
    // fetchLocationImageList() {
    //   const params = {
    //     page: 1,
    //     itemsPerPage: 20,
    //     location_id: this.item?.id,
    //   };
    //   this.$store.dispatch("csmsLocations/locationImgList", params);
    // },
  },
};
</script>
